// extracted by mini-css-extract-plugin
export default {"image":"Post_image__O6btw","gradient":"Post_gradient__AjcEC","card":"Post_card__Rn6z9","name":"Post_name__jbAWP"};